import { apiClient } from "api/APIClient";
import { entityAPI, getPathwayData } from "api/GenericAPI";
import { nodeAPI, edgeAPI } from "api/GenericPathwayAPI";

import {
  Person,
  Community,
  Community_Node_Backend,
  Community_Edge_Backend,
  Community_Pathway_Backend,
  CommunityPathwayFlow,
  Output_Node,
} from "api/Community/CommunityInterfaces";

import {
  Functionality_Base_Backend,
  Functionality_Value_Base_Backend,
  Node_Type,
} from "api/GenericPathwayInterfaces";

import { transformCommunityPathwayToFlow } from "./CommunityTransformations";

// ===================================================
// 🔹 Community CRUD API
// ===================================================
export const communityAPI = entityAPI<Community>("community", "community");
export const communityNodeTypesAPI = entityAPI<Node_Type>("community", "community/node_types");

export const functionalityAPI = entityAPI<
  Functionality_Base_Backend
>("community", "community/functionalities");
  
export const functionalityValuesAPI = entityAPI<
  Functionality_Value_Base_Backend
>("community", "community/functionality_values");

export const communityNodeAPI = nodeAPI<Community_Node_Backend>("community/community");
export const communityEdgeAPI = edgeAPI<Community_Edge_Backend>("community/community");


// ===================================================
// 🔹 Custom Endpoints
// ===================================================

/** Fetch standardized pathway data (summary + nodes + edges) */
export const getCommunityPathwayData = async (
  id: string
): Promise<CommunityPathwayFlow> => {
  return getPathwayData<Community_Pathway_Backend, CommunityPathwayFlow>(
    `/community/${id}/community_pathway/`,
    transformCommunityPathwayToFlow
  );
};


/** Get all people within a node */
export const getNodePeople = async (nodeId: number): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(
    `/community/community/nodes/${nodeId}/people/`
  );
  return data;
};

export const getOutputNodes = async (nodeId: number): Promise<Output_Node[]> => {
  const { data } = await apiClient.get<Output_Node[]>(
      `/community/community/${nodeId}/get_output_nodes/`
    );
    return data;
}

/** Move selected people between nodes */
/** Move selected people from one node to another */
export const moveItemsBetweenNodes = async (params: {
  node_id?: number;
  item_field_name: string;          // "people" | "addresses" | etc
  selected_items: number[];         // ids only
  selected_id: string;              // functionality id
  direction: "forward" | "backward";
  interaction_id?: number;
  interaction_type?: string;
}): Promise<any> => {
  const { data } = await apiClient.post(
    `/community/move_items_between_nodes/`,
    params,
  );
  return data;
};


/** Recalculate community pathway */
export const recalculateCommunityPathway = async (
  communityId: string): Promise<Person[]> => {
  const { data } = await apiClient.get<Person[]>(
    `/community/community/${communityId}/recalculate/`
  );
  return data;
};

